var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.891,
    height: 14.89,
    viewBox: "0 0 14.891 14.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-call",
    "data-name": "Icon ionic-ios-call",
    d: "M18.951,16.162a12.508,12.508,0,0,0-2.613-1.748c-.783-.376-1.07-.368-1.624.031-.461.333-.76.644-1.291.527a7.7,7.7,0,0,1-2.593-1.919c-.472-.472-1.412-1.635-1.412-1.635a4.75,4.75,0,0,1-.507-.958c-.112-.535.2-.83.527-1.291.4-.554.411-.841.031-1.624A12.261,12.261,0,0,0,7.721,4.931c-.57-.57-.7-.446-1.012-.333a5.757,5.757,0,0,0-.926.492A2.8,2.8,0,0,0,4.67,6.265c-.221.477-.477,1.365.826,3.683a20.549,20.549,0,0,0,3.613,4.819h0l0,0,0,0h0a20.63,20.63,0,0,0,4.819,3.613c2.318,1.3,3.206,1.047,3.683.826A2.747,2.747,0,0,0,18.792,18.1a5.758,5.758,0,0,0,.492-.926C19.4,16.86,19.525,16.732,18.951,16.162Z",
    transform: "translate(-4.49 -4.502)",
    fill: "#f5aa16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.6c813cf897749e743cc082323137a983.svg";
export { ForwardRef as ReactComponent };